import { useCallback, useState } from "react";
import { ExportPatientDataAPI } from "../../../api/API";

const DEFAULT_ERROR_MESSAGE = "Não foi possível exportar os dados deste paciente.";

function saveFile(blob, fileName) {
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
}

/**
 * Exportação de dados do paciente (LGPD): baixa o ZIP com tudo o que a clínica
 * tem do paciente e controla o estado de carregamento/erro. Quem usa o hook
 * decide como avisar o usuário (toast, alerta etc.).
 * Especificação: docs/features/lgpd-eliminacao/README.md
 */
function usePatientExport(patientId) {
    const [exporting, setExporting] = useState(false);
    const [exported, setExported] = useState(false);
    const [error, setError] = useState(null);

    const exportNow = useCallback(async () => {
        setExporting(true);
        setError(null);

        try {
            const { blob, fileName } = await ExportPatientDataAPI(patientId);
            saveFile(blob, fileName || `paciente-${patientId}.zip`);
            setExported(true);
            return { success: true };
        } catch (err) {
            const message = err?.message || DEFAULT_ERROR_MESSAGE;
            setError(message);
            return { success: false, error: message };
        } finally {
            setExporting(false);
        }
    }, [patientId]);

    return { exporting, exported, error, exportNow };
}

export default usePatientExport;
